import * as React from 'react';

export const Flash = ({ text, color = 'blue' }: any) => (
  <div className={`b lh-copy f5 bg-${color} white pa2 ph3 br2 mb2`}>{text}</div>
);

export const WarningFlash = ({ text }: any) => (
  <div className="b lh-copy f5 bg-gold white pa2 ph3 br2 mb2">{text}</div>
);

export const ErrorFlash = ({ error }: { error: Error }) => (
  <div className="b lh-copy f5 bg-light-red white pa2 ph3 br2 mb2 animated fadeIn">
    {error.message}
  </div>
);

export const SuccessFlash = ({ text }: { text: string }) => (
  <div className="b lh-copy f5 bg-green black pa2 ph3 br2 mb2 animated fadeIn">
    {text}
  </div>
);

export default Flash;
